module.exports = __webpack_public_path__ + "static/jc04657-preparation-step-04-d30f586354e92d966e870680320a698c.png";